import React, { useEffect, useRef, useState } from "react";
import { formatDates, validateEmail, validatePhone } from "../../../utils";
import { MdContentCopy } from "react-icons/md";
import CopyToClipboard from "react-copy-to-clipboard";
import TooltipMsg from "../TooltipMsg";
import { DatePicker } from "react-datepicker";
function InputBox(props) {
  const {
    handleChange,
    submit,
    required,
    key_name,
    label,
    placeholder,
    disab,
    validation,
    type,
    style,
    onCopyText,
    maxChar,
    previousAppointmentDate,
    labelStyle,
    msg,
    mandatory,
  } = props;
  const [error, setError] = useState(false);
  const dateInputRef = useRef(null);
  const timeInputRef = useRef(null);

  useEffect(() => {
    if (submit) {
      if (validation === "email") {
        setError(!validateEmail(props[key_name], required));
      } else if (validation === "phone") {
        setError(!validatePhone(props[key_name], required));
      } else if (validation === "required") {
        setError(!props[key_name]);
      } else if (validation === "wellnessImage") {
      }
    }
  }, [submit]);

  const currentDate = new Date().toISOString().split("T")[0];
  const path = window.location.pathname;
  if (path.split("/")[2] === "reschedule"){

  }
  // console.log(currentDate,"currentDate",previousAppointmentDate);
  // console.log(formatDates(previousAppointmentDate));

  const handleDateClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const handleTimeClick = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };
  
  return (
    <div>
      <label className={labelStyle ? labelStyle : "label"}>
        {label} {mandatory && <span style={{ color: "red" }}>*</span>}
        {msg && <TooltipMsg msg={msg} />}
      </label>
      {type === "date" ? (
        <input
          type="date"
          value={props[key_name]} 
          ref={dateInputRef}
          onClick={handleDateClick}
          className={style ? style : "input-style"}
          style={{ border: error && submit ? "1px solid red" : "" }}
          name={key_name}
          onChange={(e)=>handleChange(e)}
          min={
            path.split("/")[2] === "reschedule" ? currentDate : previousAppointmentDate
              ? formatDates(previousAppointmentDate)
              : currentDate
          }
          disabled={disab}
        />
      ) : type === "time" ? (
        <input
          type="time"
          value={props[key_name]}
          ref={timeInputRef}
          className={style ? style : "input-style"}
          style={{ border: error && submit ? "1px solid red" : "" }}
          name={key_name}
          onChange={handleChange}
          onClick={handleTimeClick}
          disabled={disab}
        />
      ) : type === "file" ? (
        <>
          <input
            type="file"
            className={style ? style : "input-style"}
            placeholder={placeholder}
            style={{
              border: error && submit ? "1px solid red" : "",
              paddingTop: `${
                props.key_name === "wellnessImage" ? "5px" : "10px"
              }`,
            }}
            name={key_name}
            onChange={handleChange}
            disabled={disab}
          />
          {key_name == "wellnessImage" && (
            <span>Maximum file size 400 KB </span>
          )}
        </>
      ) : type === "number" ? (
        <input
          type="text"
          value={props[key_name]}
          className={style ? style : "input-style"}
          placeholder={placeholder}
          style={{ border: error && submit ? "1px solid red" : "" }}
          name={key_name}
          onKeyDown={(e) => {
            const charCode = e.which ? e.which : e.keyCode;

            if (
              (charCode < 48 || charCode > 57) &&
              charCode !== 8 &&
              charCode !== 46 &&
              props[key_name].length >= maxChar
            ) {
              e.preventDefault();
            }
          }}
          onChange={handleChange}
          min={0}
          step={1}
          disabled={disab}
        />
      ) : (
        <input
          type={type}
          value={props[key_name]}
          className={style ? style : "input-style"}
          placeholder={placeholder}
          style={{ border: error && submit ? "1px solid red" : "" }}
          name={key_name}
          onChange={handleChange}
          min={0}
          step={key_name === "appointmentTime" ? 60:key_name === "bloodTestTime"? 60 : 1}
          disabled={disab}
        />
      )}
      {onCopyText && (
        <CopyToClipboard text={props[key_name]} onCopy={onCopyText}>
          <MdContentCopy className="copy-to cursor" />
        </CopyToClipboard>
      )}
    </div>
  );
}

export default React.memo(InputBox);
